//noinspection JSFileReferences
import index from './articles/index.js';

index.init();